import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/three-dots.png'
import _imports_1 from '@/assets/images/icons/pen.png'
import _imports_2 from '@/assets/images/icons/calendar.png'
import _imports_3 from '@/assets/images/icons/trash.png'
import _imports_4 from '@/assets/images/illustrations/not_found.png'


const _withScopeId = n => (_pushScopeId("data-v-6809acf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-30 px-10 md-down:px-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_4 = { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-nowrap gap-8 items-stretch" }
const _hoisted_8 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, " Tổng số lớp bán trú ", -1))
const _hoisted_10 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_11 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, " Giáo viên bán trú ", -1))
const _hoisted_13 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_14 = { class: "mt-10" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "-my-2 sm:-mx-6 lg:-mx-8" }
const _hoisted_17 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_18 = { class: "shadow sm:rounded-lg" }
const _hoisted_19 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
    }, " Số thứ tự "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tên lớp bán trú "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Số học sinh "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Giáo viên "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Hoạt động "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700 w-40" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_30 = { class: "ml-4 text-blue-600 font-semibold" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700 w-40" }
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "w-full flex justify-end pr-6 relative" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "absolute menu-action py-1 z-10"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-700" }, " Chỉnh sửa lớp bán trú ", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-700" }, " Chỉnh sửa lịch học ", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-700" }, " Chỉnh sửa hoạt động ", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-700" }, " Xoá lớp bán trú ", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  key: 1,
  class: "w-full h-full mt-20 flex items-center justify-center flex-col"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  height: "250",
  width: "250"
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Trung tâm chưa có lớp bán trú nào. ", -1))
const _hoisted_58 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateCalenderDaycare = _resolveComponent("UpdateCalenderDaycare")!
  const _component_CreateBoarding = _resolveComponent("CreateBoarding")!
  const _component_DeleteConfirm = _resolveComponent("DeleteConfirm")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_EditActivities = _resolveComponent("EditActivities")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_UserGroup = _resolveComponent("UserGroup")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.actionType === _ctx.modalType.UPDATE_CALENDER)
          ? (_openBlock(), _createBlock(_component_UpdateCalenderDaycare, {
              key: 0,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalIsOpen = false)),
              onUpdated: _ctx.updatedCalender,
              boarding: _ctx.boardingEditData
            }, null, 8, ["onUpdated", "boarding"]))
          : _createCommentVNode("", true),
        (
				_ctx.actionType === _ctx.modalType.CREATE ||
				_ctx.actionType === _ctx.modalType.UPDATE
			)
          ? (_openBlock(), _createBlock(_component_CreateBoarding, {
              key: 1,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalIsOpen = false)),
              onSubmit: _ctx.createRBoarding,
              onUpdate: _ctx.updateBoarding,
              onCreated: _ctx.createdStaffBoarding,
              "boarding-data": _ctx.boardingEditData,
              staffs: _ctx.staffs
            }, null, 8, ["onSubmit", "onUpdate", "onCreated", "boarding-data", "staffs"]))
          : _createCommentVNode("", true),
        (_ctx.actionType === _ctx.modalType.DELETE)
          ? (_openBlock(), _createBlock(_component_DeleteConfirm, {
              key: 2,
              success: _ctx.createdData,
              "onUpdate:success": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createdData) = $event)),
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalIsOpen = false)),
              title: _ctx.titleModal,
              label: _ctx.labelModal,
              "text-data": "Lớp bán trú",
              "value-data": _ctx.boardingDeleteData.name,
              error: _ctx.setup.deleteBoarding__error,
              "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setup.deleteBoarding__error) = $event)),
              onSubmit: _ctx.deleteData
            }, null, 8, ["success", "title", "label", "value-data", "error", "onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.sideOverShow ? 'side-over--active' : '')
    }, [
      (_ctx.sideOverShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sideOverShow = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_EditActivities, {
        onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sideOverShow = false)),
        boarding: _ctx.boardingEditData,
        onSubmit: _ctx.editActivities,
        open: _ctx.sideOverShow
      }, null, 8, ["boarding", "onSubmit", "open"])
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_DaIcon, {
                  name: "das--spoon",
                  class: "mr-3 h-6 w-6"
                }),
                _createTextVNode(" Lớp bán trú ")
              ]),
              (_ctx.boardings.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createModal && _ctx.createModal(...args)))
                    }, " Tạo lớp bán trú mới ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.boardings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.total), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.totalTeacher), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("table", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardings, (boarding, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: boarding.id,
                                    class: _normalizeClass([
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "hover:bg-orange-50 cursor-pointer"]),
                                    onClick: ($event: any) => (
													_ctx.$router.push(
														`/daycare-class/${boarding?.id}`
													)
												)
                                  }, [
                                    _createElementVNode("td", _hoisted_22, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", _hoisted_23, _toDisplayString(boarding.name), 1),
                                    _createElementVNode("td", _hoisted_24, [
                                      (
															boarding.numbers_of_student >
															0
														)
                                        ? (_openBlock(), _createBlock(_component_UserGroup, {
                                            key: 0,
                                            data: 
															boarding?.students
														,
                                            placement: "bottom-start"
                                          }, null, 8, ["data"]))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit",
                                            onClick: _withModifiers(($event: any) => (
															_ctx.$router.push(
																`/add-students/${boarding.id}`
															)
														), ["stop"])
                                          }, " Thêm học sinh ", 8, _hoisted_25))
                                    ]),
                                    _createElementVNode("td", _hoisted_26, [
                                      (
															boarding.staffs
																.length > 0
														)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boarding.staffs, (staff) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "flex items-center mb-2",
                                                key: staff.id
                                              }, [
                                                (
																	staff
																		?.profile_photo
																		?.w200
																)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                                      src: 
																	staff
																		?.profile_photo
																		?.w200
																,
                                                      alt: ""
                                                    }, null, 8, _hoisted_28))
                                                  : (_openBlock(), _createElementBlock("span", {
                                                      key: 1,
                                                      class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                                      style: _normalizeStyle({
																	background:
																		staff
																			?.profile_photo
																			?.default
																			?.color,
																})
                                                    }, [
                                                      _createElementVNode("span", _hoisted_29, _toDisplayString(staff
																			?.profile_photo
																			?.default
																			?.initial), 1)
                                                    ], 4)),
                                                _createElementVNode("div", _hoisted_30, _toDisplayString(staff?.name), 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit",
                                              onClick: _withModifiers(($event: any) => (
																_ctx.editData(
																	boarding
																)
															), ["stop"])
                                            }, " Thêm giáo viên ", 8, _hoisted_32)
                                          ]))
                                    ]),
                                    _createElementVNode("td", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boarding.day_care_activities.slice(
																0,
																5
															), (a) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "flex flex-col",
                                            key: a.id
                                          }, _toDisplayString(a.name), 1))
                                        }), 128)),
                                        (
																boarding
																	.day_care_activities
																	.length > 5
															)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, " ... "))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("img", {
                                          onClick: _withModifiers(($event: any) => (
																_ctx.openMenuAction(
																	boarding.id
																)
															), ["stop"]),
                                          class: "w-6 h-6 cursor-pointer",
                                          src: _imports_0,
                                          alt: ""
                                        }, null, 8, _hoisted_37),
                                        (
																_ctx.actionMenu &&
																boarding.id ==
																	_ctx.id
															)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                              _createElementVNode("div", {
                                                onClick: _withModifiers(($event: any) => (
																	_ctx.editData(
																		boarding
																	)
																), ["stop"]),
                                                class: "flex items-center gap-3 px-4 py-2"
                                              }, _hoisted_42, 8, _hoisted_39),
                                              _createElementVNode("div", {
                                                onClick: _withModifiers(($event: any) => (
																	_ctx.updateCalender(
																		boarding
																	)
																), ["stop"]),
                                                class: "flex items-center gap-3 px-4 py-2"
                                              }, _hoisted_46, 8, _hoisted_43),
                                              _createElementVNode("div", {
                                                onClick: _withModifiers(($event: any) => (
																	_ctx.editActivity(
																		boarding
																	)
																), ["stop"]),
                                                class: "flex items-center gap-3 px-4 py-2"
                                              }, _hoisted_50, 8, _hoisted_47),
                                              _createElementVNode("div", {
                                                onClick: _withModifiers(($event: any) => (
																	_ctx.deleteModal(
																		boarding
																	)
																), ["stop"]),
                                                class: "flex items-center gap-3 px-4 py-2"
                                              }, _hoisted_54, 8, _hoisted_51)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ], 10, _hoisted_21))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _hoisted_56,
                  _hoisted_57,
                  _createElementVNode("button", {
                    type: "button",
                    class: "h-12 button-p btn--ghost text-center px-6 whitespace-nowrap mt-4 w-max",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.createModal && _ctx.createModal(...args)))
                  }, " Tạo lớp bán trú mới ")
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}